import Bootstrap from "./Bootstrap.png";
import Css from "./Css.svg";
import HTML from "./HTML.svg";
import github from "./github.png" 
import Java from "./Java.svg";
import javascript from "./javascript.svg";
import react from "./react.svg.png";
import Mongo from "./Mongo.png";
import logo from "./Logo.svg"
// import Business from "./Business.webp"
import gmail from "./gmail.png"
// import insta from "./insta.jpg"
// import dev  from "./deve.avif"
import tailwind from "./tailwind.png";
// import Bug from "./Bug.svg"
// import perform from "./Perform.png"
// import group from "./group.png"
import express from "./express.png"
import node from "./node.png"
// import leave  from "./leave.jpg"
import ecom1 from "./ecom-p1.png"
import ecom2 from "./ecom-p2.png"
// import circle from "./cricle.jpg"
import estate1 from "./estate1.png"
import estate2 from "./estate2.png"
// import Herobg from "./Herobg.jpg"
import zerodha1 from "./zerodha1.png"
import zerodha2 from "./zerodha2.png"
// import Backgroundclip from "./Background.mp4"
// import tech from "./techclip.mp4"
import docker from "./docker.png"
// import hero from "./hero_main.avif"
// import project from "./projects.avif"
// import navbar from "./navbar_mini.webp"
import close from "./close.png"
import open from "./open.png"
import Linkedin from "./Linkedin.svg"
import Twitter from "./Twitter.svg"
import main_hero from "./main_hero.png"
import About from './About.png'
import discord from "./Discord.svg"

export const Icon = {
    About,
    discord,
    main_hero,
    Linkedin,
    Twitter,
    github,
    close,
    open,
    docker,
    // navbar,
    // tech,
    // hero,
    // project,
    // Backgroundclip,
    HTML,
    Css,
    javascript,
    react,
    Java,
    Mongo,
    Bootstrap,
    tailwind,
    // Business,
    gmail,
    // insta,
    // dev,
    // perform,
    // group,
    express,
    node,
    // leave,
    // Bug
    logo,
    ecom1,
    ecom2,
    // circle,
    estate1,
    estate2,
    // person,    
    zerodha1,
    zerodha2
    // Herobg
};
